import React from 'react'

export class DialogComponent extends React.Component {
  constructor(props) {
    super(props)
    this.close = this.close.bind(this)
    this.state = {
      style: this.initialize(props)
    }
  }

  initialize(prms) {
    if(window.innerWidth <= 900) {
      return {
        width: '100%',
        heigth: '100%'
      }
    }

    if(prms.width == 'auto' && prms.height == 'auto') {
      return {
        transform: 'translate(-50%, -50%)'
      }
    }
    
    let s = {
      width: 400,
      height: 250
    }

    if(prms.width && prms.width != 'auto') {
      s.width = parseInt(prms.width)
    }
    if(prms.height && prms.height != 'auto') {
      s.height = parseInt(prms.height)
    }

    s.marginLeft = -s.width / 2
    s.marginTop = -s.height / 2

    return s
  }

  componentWillReceiveProps(nextProps) {
    this.setState((ps)=> {
      ps.style = this.initialize(nextProps)
      return ps
    })
  }

  close(e) {
    if(e)
      e.preventDefault()
    this.props.onClose()
  }

  render() {
    if(!this.props.opened)
      return null
    return (
      <div className="dialog">
        <div className="dialog__bg" onClick={this.close}></div>
        <div className="dialog__content" style={this.state.style}>
          <div className="dialog__close" onClick={this.close}></div>
          {this.props.children}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/javascript/website_default/js/react/shared/dialog/dialog.component.jsx